import {SunIcon, MinimalIcon, MoonIcon, GitHubIcon} from '../components/icons';

const THEME_CYCLE = {dark: 'light', light: 'minimal', minimal: 'github', github: 'dark'};
const THEME_ICONS = {dark: SunIcon, light: MinimalIcon, minimal: GitHubIcon, github: MoonIcon};
const THEME_LABELS = {dark: 'Dark', light: 'Light', minimal: 'Minimal', github: 'GitHub'};

export function getNextThemeIcon(theme) {
    const Icon = THEME_ICONS[theme] || MoonIcon;
    return <Icon />;
}

export function getNextThemeLabel(theme) {
    const next = THEME_CYCLE[theme] || 'dark';
    return THEME_LABELS[next];
}

export {THEME_LABELS};
